import { toValue } from "vue";
import type { Fetch } from "ofetch";
import { useNuxtApp } from "nuxt/app";
import type { IRequestParams } from "../typings";

export default <R = unknown>(
  url: MaybeRef<string>,
  params?: IRequestParams<R>,
  transport?: Fetch,
) => {
  const $fetch = (transport as Fetch) ?? useNuxtApp().$transport;
  return $fetch(toValue(url), params as any) as Promise<R>;
};
